import React from "react";
import {withRouter} from "react-router-dom";
import {useAppStore} from "../../common/app.store.consumer";
import {guard, isLoggedIn} from "../../common/guard";
import {AppStore} from "../../stores/app.store";
import ReportDetails from "./components/report.details";
import PdfDownload from "./components/pdf.download";
import ReportSummary from "./components/report.summary";
import ReportSelectorAndChartPanel from "./components/report.selector.and.charts.panel";
import {RouteComponentProps} from "react-router";
import {ProfessionalProfileRoutes} from "../../stores/site.map";
import TrainingContent from "../training-content/training.content";
import {ProfessionalProfile} from "../../common/constants";
import ReportDebugPanel from "./components/report.debug.panel";
import LoadingOverlay from "../../loading-overlay/loading.overlay";
import NonMemberCallToActionPanel from "../report-page/components/report.nonmember.call.to.action.panel";
import RetakeAssessmentButton from "./components/retake.assessment.button";

type Props = {appStore?: AppStore} & RouteComponentProps;
interface State {
	answerSheetId: string;
	isLoadingAnswerSheetDetails: boolean;
	isPdf: boolean;
}

@guard(isLoggedIn)
@useAppStore()
class ReportPage extends React.Component<Props, State> {
	private reportPageStore = this.props.appStore.reportPageStore;
	private userStore = this.props.appStore.userStore;

	constructor(props: Props) {
		super(props);
		this.state = {
			answerSheetId: "",
			isLoadingAnswerSheetDetails: true,
			isPdf: false,
		};
	}

	async componentDidMount() {
		await this.reportPageStore.getUserQuestionnaireAnswerSheets();
		if (this.reportPageStore.userQuestionnaireAnswerSheets?.length < 1) {
			this.props.history.push(ProfessionalProfileRoutes.Questionnaire);
			return;
		}
		const answerSheetId = await this.reportPageStore.getNewestUserQuestionnaireAnswerDetails();
		await this.reportPageStore.getExportDownloadUrl(answerSheetId);

		// get isPdf search query from url => ?isPdf=true
		const isPdfSearchParam = new URLSearchParams(this.props.location.search.toLowerCase()).get("ispdf");
		if (isPdfSearchParam) {
			this.setState({isPdf: isPdfSearchParam === "true"});
		}

		// remove pendingAnswerSheetId from session storage
		window.sessionStorage.removeItem("pendingAnswerSheetId");
	}

	render() {
		if (this.reportPageStore.numberOfAnswerSheets === 0 || !this.reportPageStore.questionnaireAnswerSheetDetails) {
			return <LoadingOverlay message="Questionnaire history is loading..." />;
		}

		return (
			<>
				<div className="cih-inv">Used to import font to PDF, invisible</div>
				<div id="report-page" className={"cih-page cih-layout " + (this.userStore.isMember ? "report-member" : "report-nonmember")}>
					<div className="cih-2cols container">
						<div className="cih-col">
							<ReportSummary />
						</div>
						<div className="cih-spc"></div>
						<div className="cih-col">
							<ReportSelectorAndChartPanel isPdf={this.state.isPdf} />
						</div>
					</div>
					<div className="container cih-hide-print">
						<PdfDownload />
					</div>
					<div className="container cih-mt-4">{this.userStore.isMember && <TrainingContent questionnaireType={ProfessionalProfile} />}</div>
					<div className="container cih-p-0">
						<hr className="thick cih-mb-2 cih-hide-print" />
					</div>
					<div className="cih-report-details container">
						<ReportDetails />
					</div>
					<div className="cih-layout">
						{this.reportPageStore.questionnaireAnswerSheetDetails.debugPanelInfo.length !== 0 && (
							<div className="container report-debug cih-hide-print">
								<ReportDebugPanel />
							</div>
						)}
					</div>
				</div>
				{!this.userStore.isMember && <NonMemberCallToActionPanel />}
				{this.userStore.isMember &&
					<div className="cih-hide-print">
						<div className="container cih-p-0">
							<hr className="thick cih-mb-1" />
						</div>
						<div className="container cih-cta-inline"><RetakeAssessmentButton /></div>
					</div>
				}

				<LoadingOverlay
					message="Questionnaire report details are loading..."
					position={{my: "top", at: "top", of: "#report-page"}}
					visible={this.reportPageStore.isAnswerSheetDetailsLoading}
				/>
			</>
		);
	}
}

export default withRouter(ReportPage);
